document.addEventListener("DOMContentLoaded", () => {
    const searchInput = document.querySelector(".tests-search__input");
    const testsSearch = document.querySelector(".tests-search");
    const testsSearchBack = document.querySelector(".tests-search__back");

    if (searchInput === null || testsSearch === null || testsSearchBack === null) {
        return;
    }
    const resultsContainer = document.getElementById("search-results-list");
    const resultsWrapper = resultsContainer.parentNode;
    const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");
    const searchButton = document.getElementById("search-button");

    // Останавливаем любое действие кнопки, чтобы она "ничего не делала"
    searchButton.addEventListener("click", (event) => {
        event.preventDefault(); // Отмена стандартного поведения (таких как переход по ссылке или отправка формы)
    });


    let timeoutId;
    let isLoading = false;

    // Функция для скрытия результатов
    const hideResults = () => {
        resultsContainer.innerHTML = ""; // Очищаем результаты
        resultsWrapper.style.display = "none"; // Скрыть контейнер результатов
    };

    // Отмена поиска
    const cancelSearch = () => {
        clearTimeout(timeoutId); // Отменяем текущий таймер
        isLoading = false; // Сбрасываем флаг загрузки
    };

    // Функция формирования HTML результата поиска
    const renderResults = (results) => {
        resultsContainer.innerHTML = ""; // Очищаем старые результаты

        // Проверяем, массив ли это
        if (Array.isArray(results) && results.length > 0) {
            results.forEach((result) => {
                const li = document.createElement("li");
                const link = document.createElement("a");
                link.href = result.link; // Ссылка
                link.innerHTML = result.title; // Название
                li.appendChild(link);
                resultsContainer.appendChild(li);
            });

            resultsWrapper.style.display = "block"; // Показываем контейнер
        } else {
            const li = document.createElement("li");
            li.textContent = "Результаты не найдены";
            resultsContainer.appendChild(li);
            resultsWrapper.style.display = "block"; // Показываем контейнер, даже если результатов нет
        }
    };

    // Отправка консистентного запроса на сервер
    const fetchSearchResults = async (query) => {
        if (isLoading) return; // Ничего не делаем, если загрузка уже идет

        isLoading = true;

        try {
            const response = await fetch("/search", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": csrfToken,
                },
                body: JSON.stringify({query: query}),
            });

            if (!response.ok) {
                throw new Error(`Ошибка HTTP: ${response.status}`);
            }

            const data = await response.json();
            renderResults(data); // Обработка данных
        } catch (error) {
            console.error("Ошибка выполнения запроса:", error);
            hideResults();
        } finally {
            isLoading = false; // Сбрасываем флаг загрузки
        }
    };

    // Обработчик ввода текста
    searchInput.addEventListener("input", () => {
        const query = searchInput.value.trim();

        if (query.length < 3) {
            hideResults(); // Если длина меньше 3 символов, скрыть результаты
            return;
        }

        cancelSearch(); // Отменить предыдущий запрос

        timeoutId = setTimeout(() => {
            fetchSearchResults(query); // Выполнение запроса с задержкой
        }, 1000);
    });

    // Очистка поля ввода и скрытие результатов по Esc
    searchInput.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            searchInput.value = ""; // Очистить поле
            cancelSearch(); // Отменить текущий запрос
            hideResults(); // Скрыть результаты
        }
    });

    // Добавляем класс при клике на поле ввода, если его ещё нет
    searchInput.addEventListener("focus", () => {
        if (!testsSearch.classList.contains("tests-search_mobile")) {
            testsSearch.classList.add("tests-search_mobile");
        }
    });

    // Убираем класс при клике на "back"
    testsSearchBack.addEventListener("click", () => {
        testsSearch.classList.remove("tests-search_mobile");
        hideResults();
        searchInput.value = "";
    });
});
